// DS: DS6.1.3
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import omit from 'lodash/omit';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import { setRef } from '../../../../../utils/refHelpers';
import { useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import s from './ListItemDiv.scss';
/**
 * A plain, uninteractive ListItem implementation
 */ const ListItemDiv = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps, false), { rootProps: { className }, contentProps, ref } = _useListItem, rest = _object_without_properties(_useListItem.rootProps, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(BiDiv, _object_spread({
        innerRef: (node)=>setRef(ref, node),
        className: c(rest.checked && s['selected'], className)
    }, omit(rest, [
        'disabled',
        'checked',
        'isInteractive'
    ])), /*#__PURE__*/ React.createElement(ListItemContent, contentProps));
};
ListItemDiv.displayName = 'ListItemDiv';
export default ListItemDiv;
